module.exports = __webpack_public_path__ + "img/y_logo.3ef8b20b.png";